import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./welcome.sass";
import { useNavigate } from "react-router-dom";
import { BASE } from "../basedata/constants";

const OptInPage = () => {
  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAcceptTerms = () => {
    sessionStorage.setItem('user_optin', 'true');
    navigate("/signup");
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }

  const initialized = useRef(false)
  useEffect(() => {

    if (!initialized.current) {

      const params = new URLSearchParams(window.location.search)
      const currentToken = params.get('token'),
      currentCompany = params.get('orc')
  
    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
      window.location.href = `/validating?token=${currentToken}`
      
    }
  
    initialized.current = true

  }
  }, [])


  return (

    <div className="success-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />


<h1 className="bepass-title bepass-terms-title-small">{t("user_optin_page.title")}</h1>
    <p className="bepass-text-default bepass-optin-text">
Caro torcedor,<br/><br/>
Para a efetivação da compra de ingressos e acesso ao estádio, o FLAMENGO realiza 
a coleta de seus dados pessoais, em especial, de sua biometria facial, gerando 
vínculo do torcedor com o ingresso com as finalidades de garantir a lisura do 
processo de compra, minimizar tentativas de fraude, furto, roubo, dentre outras 
ilicitudes (clonagem de ingressos, venda irregular por cambistas etc.), promover 
comodidade, agilidade e segurança para a experiência do torcedor no acesso ao 
estádio e a correta correlação entre comprador / portador, pagamento e acesso ao 
estádio, o que resulta em integridade no processo.<br/><br/>
Todos os torcedores que adquirem ingressos comercializados pelo FLAMENGO – 
inclusive os de gratuidades previstos, devem ter a sua biometria facial cadastrada 
para as mesmas finalidades descritas anteriormente e o tratamento de dados está 
fundamentado nas seguintes hipóteses legais, nos termos da Lei nº 13709/2018 - 
Geral de Proteção de Dados (LGPD):<br/><br/>
•Obrigação legal ou regulatória para maiores de 16 (dezesseis) anos, nos 
termos da LGPD, descrito em seu art. 7º, inciso II para atender a 
conformidade com o que determina o art. 148º da Lei nº 14.597/2023 (Lei 
Geral do Esporte).<br/>
•Consentimento do responsável legal para o caso de menores de 16 
(dezesseis) anos (art. 7º, inciso I da LGPD)<br/><br/>
Observações:<br/>
•O tratamento de dados poderá ocorrer, excepcionalmente, mesmo sem o 
consentimento do titular, em hipóteses em que for indispensável fazê-lo 
para cumprimento de obrigação legal ou regulatória atribuída ao 
FLAMENGO ou ao FLAFLU Serviços, administrador do MARACANÃ ou por 
solicitação de órgão legitimado da Administração Pública, para a execução, 
pela administração pública, de políticas públicas previstas em leis ou 
regulamentos (art. 11 inciso II, alíneas “a” e “b” da LGPD e Lei Geral do 
Esporte).<br/>
•Dois dos benefícios implícitos na vinculação da biometria facial ao ingresso 
são o incremento na qualidade das operações de suporte ao torcedor no 
estádio (por exemplo, em casos pontuais ou fortuitos de não liberação de 
acesso do torcedor ao estádio, a equipe de suporte consegue – de forma 
significativamente mais rápida, confirmar a validade do ingresso e o vínculo 
com o torcedor; consequentemente, minimiza insatisfações na experiência 
do torcedor durante os eventos) e agilidade na prontidão operacional em 
situações adversas e/ou mais extremas, que geram riscos indesejados – 
especialmente a menores, isto é, a identificação mais rápida e facilitada de 
um determinado torcedor – naturalmente, por pessoa autorizada, pode 
fazer a diferença, se o torcedor for submetido ao perigo; especialmente, 
quando se trata de crianças e adolescentes (por exemplo, menores que se 
perdem dos seus responsáveis ou torcedores que se acidentam no interior 
do estádio).<br/><br/>
Como funciona:<br/>
O registro da biometria facial é feito por meio do nosso parceiro comercial BE PASS, 
que dispõe de uma plataforma dedicada à coleta e armazenamento da biometria. 
O sócio torcedor do FLAMENGO já possui um cadastro de dados que é gerenciado 
pelo nosso parceiro comercial FENG; os demais, realizam um cadastro para 
viabilizar a compra do ingresso, que é gerenciada pelo nosso parceiro comercial 
FUTEBOL CARD; assim, por meio do cadastro, aquele que não possui a biometria 
facial coletada é direcionado para a plataforma de registro da biometria, 
gerenciada pelo parceiro BE PASS, onde a coleta e o armazenamento acontecem. 
Para cada coleta, é gerada uma codificação segura de acesso (código hash) que é 
vinculada automaticamente ao CPF do portador do ingresso comprado na 
plataforma da FUTEBOL CARD. Essa base de registros é encaminhada ao sistema 
de acesso às catracas do estádio onde o evento esportivo será realizado, por meio 
de compartilhamento entre sistemas, próximo à data do evento. O parceiro 
comercial responsável pela gestão dos sistemas de acesso às catracas do 
MARACANÃ é a TI CONSULTING, que fica sob a gestão do grupo administrador do 
estádio, a FLAFLU Serviços – nos termos da concessão assinada entre o governo do 
Estado e os clubes de futebol Flamengo e Fluminense. Quando o torcedor chega à 
catraca, o sistema que libera o acesso mediante a confirmação da identidade do 
torcedor, validade do ingresso e a correta vinculação “torcedor portador do 
ingresso x ingresso”.<br/><br/>
O FLAMENGO mantém os dados cadastrados nas suas bases de dados por um 
determinado período diferente, a depender do dado pessoal: dados de 
identificação do sócio torcedor – inclusive o de biometria facial daquele que já 
tenha comprado ingresso após a implementação da coleta, permanecem nas bases 
de dados enquanto houver o vínculo do indivíduo com o FLAMENGO como sócio 
torcedor e por mais 24 meses, se o vínculo for desfeito, 
considerando-se a sua anuência para eventuais campanhas de resgate de sócios 
torcedores antigos. Os torcedores que adquirem ingressos, mas não se enquadram 
como sócio torcedores, tem seus dados armazenados em nossas bases por um 
período de 12 (doze) meses, a contar da última aquisição de ingresso – pago ou 
gratuito, resguardados os dados eventualmente necessários às prestações de 
contas previstas por leis ou regulamentos, tais como as demandas trabalhistas, 
fiscais etc., quando determinam tais prazos (funcionários que adquirem ingressos, 
por exemplo, terão seus dados mantidos nas bases do FLAMENGO por força das 
demandas regulatórias trabalhistas).<br/><br/>
Direitos dos titulares de dados coletados pelo FLAMENGO:<br/>
Todo indivíduo que disponibiliza dados pessoais para uma organização ou pessoa 
física, com o propósito mútuo de realizar negócios e/ou transações comerciais, 
possui direitos previstos pela LGPD, nos quais estão incluídos os direitos de solicitar 
confirmação da existência de tratamento de seus próprios dados pessoais, 
contestação, revogação de consentimento anteriormente dado, acesso aos 
seus dados tratados, correção, bloqueio, anonimização, eliminação, 
portabilidade, informações sobre compartilhamento e informações sobre a 
negação de consentimentos, dentre outras possíveis sobre os próprios dados 
pessoais. <br/><br/>
Como exercer direitos e fazer contato com o Encarregado de Dados do FLAMENGO:
O FLAMENGO dispõe de um canal de atendimento a titulares de dados para 
possibilitar o exercício dos direitos previstos pela LGPD. Caso queira exercê-lo, 
basta abrir um chamado através deste link: 
https://titulares.becompliance.com/webforms/75c21893-b94d-4046-842aa0adb7c80be6/85088d1a-dbcb-488c-b6cd-66fb35085083 . A Encarregada de Dados 
do FLAMENGO, Liliane Ferreira, receberá a sua solicitação e intermediará o contato 
com a área interna responsável pelo atendimento à sua solicitação ou pelo envio 
de justificativa, em caso de eventual impossibilidade de atender à solicitação. Em 
casos não relacionados à solicitações de exercício de direitos previstos em Lei, a 
Encarregada de Dados também pode ser contatada através do e-mail 
privacidade@flamengo.com.br.
    </p>

  <button onClick={() => handleAcceptTerms()} className="continue-button optin-button"
    >
      {t("user_optin_page.action_agree")}
    </button>

    <button onClick={() => {window.location.href = '/opt-contact'}} className="continue-button btn-ghost"
    >
    {t("user_optin_page.action_disagree")}
    </button>

        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default OptInPage;

